import { useNavigate } from "react-router-dom";

import { useStore } from "../lib/store";
import { useCallSetup } from "../lib/useCallSetup";
import { Button } from "./ui";
import { OriginateFields } from "./OriginateFields";

/**
 * Right drawer for New Call. Same originate fields as /call.
 */
export function NewCallDrawer() {
  const navigate = useNavigate();
  const { state, openNewCall } = useStore();
  const open = state.newCallOpen;
  const setup = useCallSetup({
    active: open,
    prefill: state.dialPrefill,
    onDialed: () => openNewCall(false),
  });

  if (!open) return null;

  const { busy } = setup;

  return (
    <div className="fixed inset-0 z-40 flex justify-end bg-black/55">
      <button
        type="button"
        className="h-full flex-1 cursor-default"
        aria-label="Close new call"
        onClick={() => openNewCall(false)}
      />
      <aside className="flex h-full w-full max-w-xl flex-col border-l border-teal/15 bg-frame shadow-2xl">
        <header className="flex items-center justify-between border-b border-teal/10 px-5 py-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex gap-1" aria-hidden>
                <span className="h-2 w-2 rounded-full bg-[#ff5f56]" />
                <span className="h-2 w-2 rounded-full bg-[#ffbd2e]" />
                <span className="h-2 w-2 rounded-full bg-[#27c93f]" />
              </span>
              <span className="font-mono text-[12px] text-teal">cdialer@ops — originate</span>
            </div>
            <h2 className="mt-1 text-lg font-medium text-ink">New call</h2>
          </div>
          <Button variant="ghost" onClick={() => openNewCall(false)}>
            Close
          </Button>
        </header>
        <form
          className="scroll-thin flex-1 space-y-4 overflow-auto px-5 py-5"
          onSubmit={(event) => void setup.submitDial(event)}
        >
          <OriginateFields
            setup={setup}
            onDesign={() => {
              openNewCall(false);
              navigate("/scripts");
            }}
          />
        </form>
        <div className="flex flex-wrap items-center justify-between gap-2 border-t border-teal/10 px-5 py-4">
          <div className="flex flex-wrap gap-2">
            <Button variant="ghost" className="min-h-11" onClick={() => openNewCall(false)}>
              Cancel
            </Button>
            <Button variant="ghost" className="min-h-11" disabled={busy} onClick={() => void setup.saveProfile()}>
              Save profile
            </Button>
            <Button variant="danger" className="min-h-11" disabled={busy} onClick={() => void setup.deleteProfile()}>
              Delete
            </Button>
          </div>
          <div className="flex flex-col items-end gap-1">
            {setup.dialReason ? <p className="font-mono text-[11px] text-mute">{setup.dialReason}</p> : null}
            <Button
              variant="primary"
              className="min-h-11 min-w-28 px-6"
              disabled={setup.dialBlocked}
              onClick={() => void setup.submitDial()}
            >
              Dial
            </Button>
          </div>
        </div>
      </aside>
    </div>
  );
}
